import { createContext, useContext, Dispatch, SetStateAction } from "react";

export type AgentMode = 'all' | 'environment' | 'health' | 'education';

interface ThreadContextType {
  threadId: string | null;
  setThreadId: Dispatch<SetStateAction<string | null>>;

  isNewChat: boolean;
  setIsNewChat: (val: boolean) => void;
  threaddbId: string | null;
  setThreaddbId: Dispatch<SetStateAction<string | null>>;

  agentMode: AgentMode;
  setAgentMode: Dispatch<SetStateAction<AgentMode>>;

  // The report (source) the chat is currently scoped to, if any. When set,
  // retrieval is restricted to this single report on the backend.
  sourceId: string | null;
  setSourceId: Dispatch<SetStateAction<string | null>>;
  sourceTitle: string | null;
  setSourceTitle: Dispatch<SetStateAction<string | null>>;

  // Called by ChatContainer when it lazily creates a thread on first message.
  onThreadCreated?: (thread: any) => void;
  // Called by ChatContainer after auto-renaming the thread on first response.
  onThreadRenamed?: (dbId: string, newName: string) => void;
}

const ThreadContext = createContext<ThreadContextType>({
  threadId: null,
  setThreadId: () => {},
  isNewChat: false,
  setIsNewChat: () => {},
  threaddbId: null,
  setThreaddbId: () => {},
  agentMode: 'all',
  setAgentMode: () => {},
  sourceId: null,
  setSourceId: () => {},
  sourceTitle: null,
  setSourceTitle: () => {},
  onThreadCreated: undefined,
  onThreadRenamed: undefined,
});

export const useThread = () => useContext(ThreadContext);
export default ThreadContext;
